//@flow
import * as Immutable from 'immutable';

import { PjpMetricQuery } from 'common/models/flow/PjpMetricQuery';
import type { PjpMetricQueryModelType } from 'common/models/flow/PjpMetricQuery';
import { validatable, validate } from 'common/utils/ValidationUtil';
import I18nHelper from 'common/helpers/I18nHelper';

const translationsNamespace = ['entityManagement'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

@validatable
class InternalPjpMetricQuery extends PjpMetricQuery {
    static fromJS(json: PjpMetricQueryModelType): InternalPjpMetricQuery {
        const state: Object = Object.assign({}, json);
        state.groupBy = Immutable.List(state.groupBy);
        return new this(Immutable.Map(state));
    }

    @validate
    setMetric(metric: string): this {
        return super.setMetric(metric);
    }

    validateMetric() {
        const { metric } = this;
        if (!metric) {
            return nsTranslate('pjpAnalytics.errors.metricIdEmptyError');
        }
        return null;
    }

    @validate
    setAggregationType(aggregationType: string): this {
        return super.setAggregationType(aggregationType);
    }

    validateAggregationType() {
        const { aggregationType } = this;
        if (!aggregationType) {
            return nsTranslate('pjpAnalytics.errors.aggregateEmptyError');
        }
        return null;
    }
    @validate
    setGroupBy(groupBy: Immutable.List<string>): this {
        return super.setGroupBy(groupBy);
    }

    validateGroupBy() {
        const { groupBy, aggregationType } = this;
        if (!groupBy || !groupBy.size) {
            return nsTranslate('pjpAnalytics.errors.groupTypeEmptyError');
        }
        if (groupBy.size > 2) {
            return nsTranslate('pjpAnalytics.errors.groupByLessThanTwo');
        }
        if (aggregationType === 'AVG' && groupBy.size > 1) {
            return nsTranslate('pjpAnalytics.errors.groupByAggError');
        }
        return null;
    }
}

export { InternalPjpMetricQuery as PjpMetricQuery };
